import { addShapes, removeShapes, addOnMouseMove, removeOnMouseMove } from './src/utils/background';

export const onRouteUpdate = ({ location }) => {
  window.clearTimeout(window.experimentTimeout);
  window.cancelAnimationFrame(window.experimentRequestAnimationFrame);
  switch(location.pathname){
    case '/':
      addShapes();
      addOnMouseMove();
      break;
    default:
      removeShapes();
      removeOnMouseMove();
      break;
  }
}



// WEBPACK FOOTER //
// ./gatsby-browser.js